import { defineMessages } from 'react-intl';

export default defineMessages({
  inventory: {
    id: 'itemtype.inventory.title',
    defaultMessage: 'Inventory'
  },
  noninventory: {
    id: 'itemtype.noninventory.title',
    defaultMessage: 'Non Inventory'
  },
  matrix: {
    id: 'itemtype.matrix.title',
    defaultMessage: 'Matrix'
  },
  shipping: {
    id: 'itemtype.shipping.title',
    defaultMessage: 'Shipping'
  },
  serialized: {
    id: 'itemtype.serialized.title',
    defaultMessage: 'Serialized'
  },
  batch: {
    id: 'itemtype.batch.title',
    defaultMessage: 'Batch'
  },
  service: {
    id: 'itemtype.service.title',
    defaultMessage: 'Service'
  },
  discount: {
    id: 'itemtype.discount.title',
    defaultMessage: 'Discount'
  },
  bundle: {
    id: 'itemtype.bundle.title',
    defaultMessage: 'Bundle'
  },
  giftcertificate: {
    id: 'itemtype.giftcertificate.title',
    defaultMessage: 'Gift Certificate'
  },
  loyalty: {
    id: 'itemtype.loyalty.title',
    defaultMessage: 'Loyalty'
  },
  promotion: {
    id: 'itemtype.promotion.title',
    defaultMessage: 'Promotion'
  },
  coupon: {
    id: 'itemtype.coupon.title',
    defaultMessage: 'Coupon'
  },
  payment_surcharge: {
    id: 'itemtype.payment_surcharge.title',
    defaultMessage: 'Payment Surcharge'
  },
  service_charge: {
    id: 'itemtype.service_charge.title',
    defaultMessage: 'Service Charge'
  },
  gratuity: {
    id: 'itemtype.gratuity.title',
    defaultMessage: 'Gratuity'
  }
});
